import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import LucideIcon from '../../../componentes/lucide-icon';
import StatusBadge from '../../../componentes/StatusBadge';
import InputBusca from '../../../componentes/input-busca';
import { STATUS_BADGE } from '../../../utils/constants';
import { normalizeSearchText } from '../../../utils/string';
import { UncontrolledTooltip } from 'reactstrap';
import './drag-drop.css';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

// using some little inline style helpers to make the app look okay
const getItemStyle = (draggableStyle, isDragging, required) => ({
  fontSize: '14px',
  userSelect: 'none',
  padding: '0px',
  margin: `0 0 0px 0`,
  cursor: !required && 'move',
  background: isDragging ? 'white' : required ? '#fee0bd' : 'white',
  ...draggableStyle,
});

const obterDraggableId = (item) => `${item.id ? item.id : item.valueField}`;

const obterDescricao = (item) =>
  item.descricao || item.headerText || item.valueField;

const ehObrigatorio = (item) =>
  item.descricao ? item.obrigatorio : item.required ? item.required : false;

const ehSomenteExportacao = (item) => !!item.somenteExportacao;

const filtrar = (lista, termo) => {
  if (!lista) return [];
  if (!termo) return lista;

  const termoNormalizado = normalizeSearchText(termo);
  return lista.filter((item) =>
    normalizeSearchText(obterDescricao(item)).includes(termoNormalizado)
  );
};

const obterIndiceListaCompleta = (listaCompleta, listaFiltrada, indiceFiltrado) => {
  if (!listaFiltrada.length) return listaCompleta.length;
  if (indiceFiltrado >= listaFiltrada.length) return listaCompleta.length;

  const itemDestino = listaFiltrada[indiceFiltrado];
  const indiceCompleto = listaCompleta.findIndex(
    (item) => obterDraggableId(item) === obterDraggableId(itemDestino)
  );

  return indiceCompleto === -1 ? listaCompleta.length : indiceCompleto;
};
class DragDropComponent extends React.Component {
  static defaultProps = {
    palavraChave: 'Colunas',
    esconderColunasDisponiveis: false,
    layoutNovo: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      buscaDisponiveis: '',
      buscaUsadas: '',
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.moverTodasParaUsadas = this.moverTodasParaUsadas.bind(this);
    this.moverTodasParaDisponiveis = this.moverTodasParaDisponiveis.bind(this);
    this.handleBuscaDisponiveis = this.handleBuscaDisponiveis.bind(this);
    this.handleBuscaUsadas = this.handleBuscaUsadas.bind(this);
  }

  handleBuscaDisponiveis(event) {
    this.setState({ buscaDisponiveis: event.target.value });
  }

  handleBuscaUsadas(event) {
    this.setState({ buscaUsadas: event.target.value });
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (this.props.layoutNovo) {
      this.onDragEndLayoutNovo(result);
      return;
    }

    let CamposDisponiveis = this.props.listaColunasDisponiveis.value
      ? this.props.listaColunasDisponiveis.value
      : [];
    let CamposUsados = this.props.listaColunasUsadas.value
      ? this.props.listaColunasUsadas.value
      : [];

    //Jogando itens disponíveis para a lista de usados
    //e atualizando a ordem
    if (result.destination.droppableId == 'droppable2') {
      if (this.props.isValidDragToUsedColumns) {
        const isValid = this.props.isValidDragToUsedColumns(result);
        if (!isValid) return;
      }

      if (result.source.droppableId == 'droppable') {
        CamposUsados.push(CamposDisponiveis[result.source.index]);
        CamposDisponiveis.splice(result.source.index, 1);

        let items = reorder(
          CamposUsados,
          CamposUsados.length - 1,
          result.destination.index
        );

        this.props.listaColunasUsadas.requestChange(items);
      }
      //Ordenando itens dentro da própria lista
      else {
        let items = reorder(
          this.props.listaColunasUsadas.value,
          result.source.index,
          result.destination.index
        );

        this.props.listaColunasUsadas.requestChange(items);
      }
    }

    if (result.destination.droppableId == 'droppable') {
      //Jogando itens usados para a lista de disponíresponsáveis
      //e atualizando a ordem
      if (result.source.droppableId == 'droppable2') {
        let required = ehObrigatorio(CamposUsados[result.source.index]);

        //Só retira da lista de usados os campos não obrigatórios
        if (!required) {
          CamposDisponiveis.push(CamposUsados[result.source.index]);
          CamposUsados.splice(result.source.index, 1);

          let items = reorder(
            CamposDisponiveis,
            CamposDisponiveis.length - 1,
            result.destination.index
          );

          this.props.listaColunasDisponiveis.requestChange(items);
        }
      }
      //Ordenando itens dentro da própria lista
      else {
        let items = reorder(
          this.props.listaColunasDisponiveis.value,
          result.source.index,
          result.destination.index
        );

        this.props.listaColunasDisponiveis.requestChange(items);
      }
    }
  }

  onDragEndLayoutNovo(result) {
    const disponiveis = [
      ...(this.props.listaColunasDisponiveis.value || []),
    ];
    const usadas = [...(this.props.listaColunasUsadas.value || [])];
    const disponiveisFiltradas = filtrar(disponiveis, this.state.buscaDisponiveis);
    const usadasFiltradas = filtrar(usadas, this.state.buscaUsadas);
    const draggableId = result.draggableId;
    const origemId = result.source.droppableId;
    const destinoId = result.destination.droppableId;

    if (destinoId === 'droppable2') {
      if (this.props.isValidDragToUsedColumns) {
        const isValid = this.props.isValidDragToUsedColumns(result);
        if (!isValid) return;
      }

      if (origemId === 'droppable') {
        const indiceOrigem = disponiveis.findIndex(
          (item) => obterDraggableId(item) === draggableId
        );
        if (indiceOrigem === -1) return;

        const [item] = disponiveis.splice(indiceOrigem, 1);
        const indiceDestino = obterIndiceListaCompleta(
          usadas,
          usadasFiltradas,
          result.destination.index
        );
        usadas.splice(indiceDestino, 0, item);

        this.props.listaColunasDisponiveis.requestChange(disponiveis);
        this.props.listaColunasUsadas.requestChange(usadas);
      } else {
        const indiceOrigem = usadas.findIndex(
          (item) => obterDraggableId(item) === draggableId
        );
        if (indiceOrigem === -1) return;

        const itens = reorder(
          usadas,
          indiceOrigem,
          obterIndiceListaCompleta(
            usadas,
            usadasFiltradas,
            result.destination.index
          )
        );
        this.props.listaColunasUsadas.requestChange(itens);
      }
    }

    if (destinoId === 'droppable') {
      if (origemId === 'droppable2') {
        const indiceOrigem = usadas.findIndex(
          (item) => obterDraggableId(item) === draggableId
        );
        if (indiceOrigem === -1) return;

        const item = usadas[indiceOrigem];
        if (ehObrigatorio(item)) return;

        usadas.splice(indiceOrigem, 1);
        const indiceDestino = obterIndiceListaCompleta(
          disponiveis,
          disponiveisFiltradas,
          result.destination.index
        );
        disponiveis.splice(indiceDestino, 0, item);

        this.props.listaColunasUsadas.requestChange(usadas);
        this.props.listaColunasDisponiveis.requestChange(disponiveis);
      } else {
        const indiceOrigem = disponiveis.findIndex(
          (item) => obterDraggableId(item) === draggableId
        );
        if (indiceOrigem === -1) return;

        const itens = reorder(
          disponiveis,
          indiceOrigem,
          obterIndiceListaCompleta(
            disponiveis,
            disponiveisFiltradas,
            result.destination.index
          )
        );
        this.props.listaColunasDisponiveis.requestChange(itens);
      }
    }
  }

  moverTodasParaUsadas() {
    let CamposDisponiveis = this.props.listaColunasDisponiveis.value
      ? this.props.listaColunasDisponiveis.value
      : [];
    let CamposUsados = this.props.listaColunasUsadas.value
      ? this.props.listaColunasUsadas.value
      : [];

    if (CamposDisponiveis.length === 0) return;

    // Adiciona todas as colunas disponíveis ao final da lista de usadas
    const novasColunasUsadas = [...CamposUsados, ...CamposDisponiveis];
    
    // Limpa a lista de disponíveis
    this.props.listaColunasDisponiveis.requestChange([]);
    this.props.listaColunasUsadas.requestChange(novasColunasUsadas);
  }

  moverTodasParaDisponiveis() {
    let CamposDisponiveis = this.props.listaColunasDisponiveis.value
      ? this.props.listaColunasDisponiveis.value
      : [];
    let CamposUsados = this.props.listaColunasUsadas.value
      ? this.props.listaColunasUsadas.value
      : [];

    if (CamposUsados.length === 0) return;

    // Filtra apenas as colunas não obrigatórias
    const colunasNaoObrigatorias = CamposUsados.filter(
      (item) => !ehObrigatorio(item)
    );

    if (colunasNaoObrigatorias.length === 0) return;

    // Adiciona as colunas não obrigatórias ao final da lista de disponíveis
    const novasColunasDisponiveis = [
      ...CamposDisponiveis,
      ...colunasNaoObrigatorias,
    ];

    // Remove as colunas não obrigatórias da lista de usadas
    const novasColunasUsadas = CamposUsados.filter((item) =>
      ehObrigatorio(item)
    );

    this.props.listaColunasDisponiveis.requestChange(novasColunasDisponiveis);
    this.props.listaColunasUsadas.requestChange(novasColunasUsadas);
  }

  renderLabelDisponiveis() {
    let titulo = this.props.palavraChave;

    if (titulo === 'Colunas') return 'label.colunasDisponiveis';
    else if (titulo === 'Campos') return 'camposDisponiveis';
    else if (titulo == 'Favoritos') return 'todos';
  }

  renderLabelUtilizadas() {
    let titulo = this.props.palavraChave;

    if (titulo === 'Colunas') return 'label.colunasUsadas';
    else if (titulo === 'Campos') return 'camposUsados';
    else if (titulo == 'Favoritos') return 'favoritos';
  }

  renderItemLegado(item, provided, snapshot, obrigatorio) {
    return (
      <div className={'pb-2 shadow p-0 rounded'}>
        <div
          className={'shadow p-0 rounded'}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            provided.draggableProps.style,
            snapshot.isDragging,
            obrigatorio
          )}
        >
          {obterDescricao(item)}
        </div>
        {provided.placeholder}
      </div>
    );
  }

  renderItemNovo(item, provided) {
    const obrigatorio = ehObrigatorio(item);
    const somenteExportacao = ehSomenteExportacao(item);
    const itemId = obterDraggableId(item);
    const badgeObrigatorioId = `badge-obrigatorio-${itemId}`;
    const badgeExportacaoId = `badge-exportacao-${itemId}`;

    return (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        className="dragDropItemRow"
        style={provided.draggableProps.style}
      >
        <div className="dragDropItemGrip">
          <LucideIcon icon="drag" size={16} />
        </div>
        <span className="dragDropItemTexto">{obterDescricao(item)}</span>
        {obrigatorio && (
          <>
            <span id={badgeObrigatorioId} className="dragDropBadgeWrap">
              <StatusBadge type={STATUS_BADGE.Obrigatorio}>
                <LucideIcon icon="lock" size={12} />
              </StatusBadge>
            </span>
            <UncontrolledTooltip placement="top" target={badgeObrigatorioId}>
              {this.props.intl.formatMessage({
                id: 'colunaObrigatoriaNaoPodeSerRemovida',
              })}
            </UncontrolledTooltip>
          </>
        )}
        {somenteExportacao && (
          <>
            <span id={badgeExportacaoId} className="dragDropBadgeWrap">
              <StatusBadge type={STATUS_BADGE.Exportacao} />
            </span>
            <UncontrolledTooltip placement="top" target={badgeExportacaoId}>
              {this.props.intl.formatMessage({
                id: 'colunaValidaApenasEmExportacoes',
              })}
            </UncontrolledTooltip>
          </>
        )}
      </div>
    );
  }

  renderPainelBusca(busca, onChange) {
    return (
      <InputBusca
        value={busca}
        onChange={onChange}
        placeholder={this.props.intl.formatMessage({ id: 'label.buscar' })}
      />
    );
  }

  renderPainelNovo({ droppableId, labelId, lista, busca, onBuscaChange }) {
    const listaFiltrada = filtrar(lista, busca);

    return (
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`dragDropPainelColunas${
              snapshot.isDraggingOver ? ' dragDropPainelColunasArrastando' : ''
            }`}
          >
            <div className="dragDropCabecalhoArea">
              <div className="dragDropCabecalhoNovo">
                <span className="d-flex align-items-center">
                  <FormattedMessage id={labelId} />
                  <span className="dragDropContador">
                    {lista.length}
                  </span>
                </span>
                {this.renderPainelBusca(busca, onBuscaChange)}
              </div>
            </div>
            <div className="dragDropListaItens">
              {listaFiltrada.map((item, index) => (
                <Draggable
                  index={index}
                  isDragDisabled={item.disabled}
                  key={obterDraggableId(item)}
                  draggableId={obterDraggableId(item)}
                >
                  {(draggableProvided) =>
                    this.renderItemNovo(item, draggableProvided)
                  }
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          </div>
        )}
      </Droppable>
    );
  }

  renderBotoesMoverTodas(prefixoId) {
    return (
      <div className="dragDropBotoesMover">
        <div
          id={`${prefixoId}-mover-usadas`}
          className="dragDropBotaoMoverTodas text-primary"
          onClick={this.moverTodasParaUsadas}
        >
          <LucideIcon icon="chevron-double-right" size={16} />
        </div>
        <UncontrolledTooltip
          placement="right"
          target={`${prefixoId}-mover-usadas`}
        >
          {this.props.intl.formatMessage({ id: 'moverTodas' })}
        </UncontrolledTooltip>
        <div
          id={`${prefixoId}-mover-disponiveis`}
          className="dragDropBotaoMoverTodas text-primary"
          onClick={this.moverTodasParaDisponiveis}
        >
          <LucideIcon icon="chevron-double-left" size={16} />
        </div>
        <UncontrolledTooltip
          placement="right"
          target={`${prefixoId}-mover-disponiveis`}
        >
          {this.props.intl.formatMessage({ id: 'moverTodas' })}
        </UncontrolledTooltip>
      </div>
    );
  }

  renderLegado() {
    let {
      listaColunasDisponiveis,
      listaColunasUsadas,
      esconderColunasDisponiveis,
    } = this.props;

    return (
      <div className="d-flex justify-content-center">
        <DragDropContext onDragEnd={this.onDragEnd}>
          {!esconderColunasDisponiveis && (
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  className={`dragDropListaLegado${
                    snapshot.isDraggingOver
                      ? ' dragDropListaLegadoArrastando'
                      : ''
                  }`}
                >
                  <div className="dragDropCabecalho">
                    <FormattedMessage id={this.renderLabelDisponiveis()} />
                  </div>
                  <div className="dragDropListaPadding">
                    {listaColunasDisponiveis.value &&
                      listaColunasDisponiveis.value.map((item, index) => (
                        <Draggable
                          index={index}
                          isDragDisabled={item.disabled}
                          key={obterDraggableId(item)}
                          draggableId={obterDraggableId(item)}
                        >
                          {(draggableProvided, draggableSnapshot) =>
                            this.renderItemLegado(
                              item,
                              draggableProvided,
                              draggableSnapshot,
                              false
                            )
                          }
                        </Draggable>
                      ))}
                  </div>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )}

          {!esconderColunasDisponiveis &&
            this.renderBotoesMoverTodas('legado')}

          <Droppable droppableId="droppable2">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                className={`dragDropListaLegado${
                  snapshot.isDraggingOver
                    ? ' dragDropListaLegadoArrastando'
                    : ''
                }`}
              >
                <div className="dragDropCabecalho">
                  <FormattedMessage id={this.renderLabelUtilizadas()} />
                </div>
                <div className="dragDropListaPadding">
                  {listaColunasUsadas.value &&
                    listaColunasUsadas.value.map((item, index) => (
                      <Draggable
                        index={index}
                        isDragDisabled={item.disabled}
                        key={obterDraggableId(item)}
                        draggableId={obterDraggableId(item)}
                      >
                        {(draggableProvided, draggableSnapshot) =>
                          this.renderItemLegado(
                            item,
                            draggableProvided,
                            draggableSnapshot,
                            ehObrigatorio(item)
                          )
                        }
                      </Draggable>
                    ))}
                </div>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }

  renderLayoutNovo() {
    const {
      listaColunasDisponiveis,
      listaColunasUsadas,
      esconderColunasDisponiveis,
    } = this.props;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div className="dragDropLayoutNovo">
          {!esconderColunasDisponiveis &&
            this.renderPainelNovo({
              droppableId: 'droppable',
              labelId: this.renderLabelDisponiveis(),
              lista: listaColunasDisponiveis.value || [],
              busca: this.state.buscaDisponiveis,
              onBuscaChange: this.handleBuscaDisponiveis,
            })}

          {!esconderColunasDisponiveis && this.renderBotoesMoverTodas('novo')}

          {this.renderPainelNovo({
            droppableId: 'droppable2',
            labelId: this.renderLabelUtilizadas(),
            lista: listaColunasUsadas.value || [],
            busca: this.state.buscaUsadas,
            onBuscaChange: this.handleBuscaUsadas,
          })}
        </div>
      </DragDropContext>
    );
  }

  render() {
    if (this.props.layoutNovo) {
      return this.renderLayoutNovo();
    }

    return this.renderLegado();
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(DragDropComponent));
